import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from './Container';
import PostCardGroup from './PostCardGroup';

const RecentWrapper = styled.div`
  @media screen and (max-width: 600px)  {
    margin-top: 10rem;
    }
    .Title {
      text-align: center;
    }
  section {
    margin-top: 5rem;
    flex-direction: column;
    .title, .posts {
      max-width: 100%;
      margin: auto;
    }
    }
`;

const Recent = ({ posts }) => (
  <RecentWrapper>
    <Container>
      <div className="Title">
        <h2>İnşaat Uygulamaları</h2>
        <p>Konya İnşaat firmaları Listesi , Konya İnşaat firmaları Satılık Daireler, Tadilat , Konya İnşaat firmaları, Konya Yazır İnşaat Projeleri, Konya Selçuklu İnşaat firmaları, Konya Karatay İnşaat firmaları, Konya Konut Projeleri, Konya Meram Konut Projeleri arayanlar, Ayazsan İnşaat müşterilerinin isteklerini üstün kalite anlayışı ile yapmaktadır.</p>
      </div>
      <div className="posts">
        <PostCardGroup posts={posts} topBorder={true} />
      </div>
    </Container>
  </RecentWrapper>
);

Recent.propTypes = {
  posts: PropTypes.array.isRequired,
};

export default Recent;
